import _constant from '../utils/constants';

// Takes two strings as input, format is dd-mm-yyyy
// returns true if d1 is smaller than or equal to d2
export const compareDate = (d1, d2) => {
  let parts = d1.split('/');
  d1 = Number(parts[2] + parts[1] + parts[0]);
  parts = d2.split('/');
  d2 = Number(parts[2] + parts[1] + parts[0]);
  return d1 <= d2;
};

export const formatDate = (format, date) => {
  let formattedDate = '';
  if (format && date) {
    switch (format) {
      case 'DD/MM/YYYY':
        formattedDate = dateInDDMMYYYY(date);
        break;
    }
  }
  return formattedDate;
};

export const toDate = dateStr => {
  if (dateStr) {
    let parts = dateStr.split(_constant.DATE_ORDINAL);
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return false;
};

let dateInDDMMYYYY = date => {
  date = new Date(date);
  let dd = date.getDate();
  let mm = date.getMonth() + 1; // January is 0!

  let yyyy = date.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}/${mm}/${yyyy}`;
};

export const isNumber = e => {
  if (!e) return false;
  if (typeof e !== 'object' && /^\d+$/.test(e)) return true;

  let digit = String.fromCharCode(e.which);
  if (e.key !== undefined) {
    digit = e.key;
  }
  // any other character than digit
  if (!/^\d+$/.test(digit)) {
    // allow backspace, tab and right/left arrow
    if (e.which !== 8 && e.which !== 9 && e.which !== 37 && e.which !== 39) {
      return false;
    }
  }
  return true;
};

// To check amount type in edit case i.e. for fixed & flexible amount
export const checkFixedAmountTypeEditCase = constraints => {
  return !!(constraints && constraints.value);
};
export const isFunction = method => {
  if (typeof method === 'function') {
    return true;
  }
  return false;
};

/**
 * Null or undefined check on value
 * @param {any} value - can be of any type
 * @return {Boolean} - result of value is null or undefined
 * */
export const isNull = value => {
  return value === null || value === undefined;
};

/**
 * Get property value from nested object
 *
 * @param {Object} obj - object to perform property lookup
 * @param {String} path - the path at which lookup is performed
 * @param {*} defaultValue (optional) -  default value to be reurned if property not found
 * @returns {*} - returns the property value if found else returns dafaultValue
 */
export const get = (obj, path, defaultValue) => {
  const result = String.prototype.split
    .call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  return result === undefined || result === obj ? defaultValue : result;
};

/**
 * Generate new lighter or darker color code
 * https://css-tricks.com/snippets/javascript/lighten-darken-color/
 * @param {string} col - hash code color
 * @param {boolean} isLighten - need to convert in lighter or darker
 */
export const lightenDarkenColor = (col, isLighten = true) => {
  let usePound = false;
  const amt = isLighten ? 40 : -20;

  if (col[0] == '#') {
    col = col.slice(1);
    usePound = true;
  }

  let num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};


/**
 * Convert the opacity value to Hexa Decimal
 * @param {Objec} colorObj - Color Object
 */
export const convertOpacityToHex = colorObj => {
  let a = '';
  if (colorObj && colorObj.rgb && colorObj.rgb.hasOwnProperty('a') && colorObj.rgb.a != 1) {
    a = Math.floor(colorObj.rgb.a * 255).toString(16);
    if (a.length === 1) {
      a = '0' + a;
    }
  }
  return a;
};




// WEBPACK FOOTER //
// ./common/utility.js